var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"368c2538a895f506f599c736511324eb0ec930db"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app-web@treefort-systems"]={id:"368c2538a895f506f599c736511324eb0ec930db"};
      